(function () {
  var DEFAULT_STEP = 50;

  function parseAmount(value) {
    if (value == null || value === '') return null;
    var parsed = Number(String(value).replace(/,/g, '').trim());
    return Number.isFinite(parsed) ? parsed : null;
  }

  function snapNearest(value, step) {
    return Math.round(value / step) * step;
  }

  function snapUp(value, step) {
    if (value <= 0) return 0;
    return Math.ceil(value / step) * step;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function formatMoney(amount, symbol) {
    return symbol + Math.round(amount).toLocaleString('en-US');
  }

  function isAllowedPriceInputKey(event) {
    if (event.ctrlKey || event.metaKey || event.altKey) return true;

    var allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Enter',
      'Escape',
      'Home',
      'End',
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
    ];

    if (allowedKeys.indexOf(event.key) !== -1) return true;
    if (/^[0-9]$/.test(event.key)) return true;

    return false;
  }

  class PlpPriceRange extends HTMLElement {
    connectedCallback() {
      if (this.dataset.plpPriceInit === 'true') return;
      this.dataset.plpPriceInit = 'true';

      this.minInput = this.querySelector('[data-price-min-input]');
      this.maxInput = this.querySelector('[data-price-max-input]');
      this.minRange = this.querySelector('[data-price-min-range]');
      this.maxRange = this.querySelector('[data-price-max-range]');
      this.presetButtons = this.querySelectorAll('[data-price-preset]');
      this.trackFill = this.querySelector('[data-price-track-fill]');
      this.minDisplay = this.querySelector('[data-price-min-display]');
      this.maxDisplay = this.querySelector('[data-price-max-display]');

      this.step = parseInt(this.dataset.step, 10) || DEFAULT_STEP;
      this.currencySymbol = this.dataset.currencySymbol || '$';
      this.rangeMax = snapUp((parseInt(this.dataset.rangeMaxCents, 10) || 0) / 100, this.step);
      this.activeRange = null;

      this.configureRangeInputs();
      this.bindEvents();
      this.syncFromInputs({ dispatch: false });
    }

    disconnectedCallback() {
      delete this.dataset.plpPriceInit;
    }

    configureRangeInputs() {
      [this.minRange, this.maxRange].forEach(function (input) {
        if (!input) return;
        input.min = '0';
        input.max = String(this.rangeMax);
        input.step = String(this.step);
      }, this);
    }

    bindEvents() {
      this.onMinRangeInput = this.onMinRangeInput.bind(this);
      this.onMaxRangeInput = this.onMaxRangeInput.bind(this);
      this.onMinRangeChange = this.onMinRangeChange.bind(this);
      this.onMaxRangeChange = this.onMaxRangeChange.bind(this);
      this.onMinFieldChange = this.onMinFieldChange.bind(this);
      this.onMaxFieldChange = this.onMaxFieldChange.bind(this);
      this.onMinFieldInput = this.onMinFieldInput.bind(this);
      this.onMaxFieldInput = this.onMaxFieldInput.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onRangePointerUp = this.onRangePointerUp.bind(this);

      this.minRange?.addEventListener('input', this.onMinRangeInput);
      this.maxRange?.addEventListener('input', this.onMaxRangeInput);
      this.minRange?.addEventListener('change', this.onMinRangeChange);
      this.maxRange?.addEventListener('change', this.onMaxRangeChange);
      this.minInput?.addEventListener('change', this.onMinFieldChange);
      this.maxInput?.addEventListener('change', this.onMaxFieldChange);
      this.minInput?.addEventListener('input', this.onMinFieldInput);
      this.maxInput?.addEventListener('input', this.onMaxFieldInput);
      this.minInput?.addEventListener('keydown', this.onKeyDown);
      this.maxInput?.addEventListener('keydown', this.onKeyDown);

      this.onPresetClick = this.onPresetClick.bind(this);
      this.presetButtons.forEach(function (button) {
        button.addEventListener('click', this.onPresetClick);
      }, this);

      [this.minRange, this.maxRange].forEach(function (input) {
        if (!input) return;
        input.addEventListener('pointerdown', function () {
          this.setActiveRange(input);
        }.bind(this));
        input.addEventListener('pointerup', this.onRangePointerUp);
        input.addEventListener('pointercancel', this.onRangePointerUp);
      }, this);
    }

    setActiveRange(rangeInput) {
      this.activeRange = rangeInput;
      if (rangeInput === this.minRange) {
        this.minRange.style.zIndex = '5';
        this.maxRange.style.zIndex = '4';
      } else {
        this.maxRange.style.zIndex = '5';
        this.minRange.style.zIndex = '3';
      }
    }

    onRangePointerUp() {
      this.activeRange = null;
      if (this.minRange) this.minRange.style.zIndex = '';
      if (this.maxRange) this.maxRange.style.zIndex = '';
    }

    onKeyDown(event) {
      if (isAllowedPriceInputKey(event)) return;
      event.preventDefault();
    }

    onPresetClick(event) {
      event.preventDefault();
      var button = event.currentTarget;
      // Clicking the already-active preset clears the price filter.
      var isActive = button.getAttribute('aria-pressed') === 'true';
      var minAttr = isActive ? '' : button.getAttribute('data-preset-min');
      var maxAttr = isActive ? '' : button.getAttribute('data-preset-max');

      var minVal = minAttr === '' || minAttr == null ? 0 : parseAmount(minAttr) || 0;
      var maxVal = maxAttr === '' || maxAttr == null ? this.rangeMax : parseAmount(maxAttr) || this.rangeMax;

      // Write the inputs + sliders without firing the internal change, then
      // emit one native input on a field so FacetFiltersForm re-renders.
      // applyValues() reconciles the pressed state on the chips.
      this.applyValues(minVal, maxVal, false);
      this.maxInput.dispatchEvent(new Event('input', { bubbles: true }));
    }

    onMinFieldInput() {
      this.updateFromFieldsLive('min');
    }

    onMaxFieldInput() {
      this.updateFromFieldsLive('max');
    }

    onMinRangeInput() {
      this.updateFromRanges('min', false);
    }

    onMaxRangeInput() {
      this.updateFromRanges('max', false);
    }

    onMinRangeChange() {
      this.updateFromRanges('min', true);
    }

    onMaxRangeChange() {
      this.updateFromRanges('max', true);
    }

    onMinFieldChange() {
      this.updateFromFields('min');
    }

    onMaxFieldChange() {
      this.updateFromFields('max');
    }

    updateFromRanges(source, dispatchChange) {
      var minVal = snapNearest(Number(this.minRange.value) || 0, this.step);
      var maxVal = snapNearest(Number(this.maxRange.value) || this.rangeMax, this.step);

      minVal = clamp(minVal, 0, this.rangeMax);
      maxVal = clamp(maxVal, 0, this.rangeMax);

      if (minVal > maxVal) {
        if (source === 'min') {
          maxVal = clamp(minVal, 0, this.rangeMax);
        } else {
          minVal = clamp(maxVal, 0, this.rangeMax);
        }
      }

      this.applyValues(minVal, maxVal, dispatchChange);
    }

    updateFromFields(source) {
      var minVal = parseAmount(this.minInput.value);
      var maxVal = parseAmount(this.maxInput.value);

      if (minVal == null) minVal = 0;
      else minVal = snapNearest(minVal, this.step);

      if (maxVal == null) maxVal = this.rangeMax;
      else maxVal = snapNearest(maxVal, this.step);

      minVal = clamp(minVal, 0, this.rangeMax);
      maxVal = clamp(maxVal, 0, this.rangeMax);

      if (minVal > maxVal) {
        if (source === 'min') maxVal = minVal;
        else minVal = maxVal;
      }

      this.applyValues(minVal, maxVal, true, source);
    }

    updateFromFieldsLive(source) {
      var minVal = parseAmount(this.minInput.value);
      var maxVal = parseAmount(this.maxInput.value);

      if (minVal == null) minVal = 0;
      if (maxVal == null) maxVal = this.rangeMax;

      minVal = clamp(minVal, 0, this.rangeMax);
      maxVal = clamp(maxVal, 0, this.rangeMax);

      if (minVal > maxVal) {
        if (source === 'min') maxVal = minVal;
        else minVal = maxVal;
      }

      this.minRange.value = String(minVal);
      this.maxRange.value = String(maxVal);
      this.setInputConstraints(minVal, maxVal);
      this.updateVisuals(minVal, maxVal);
    }

    applyValues(minVal, maxVal, dispatchChange, changeSource) {
      minVal = clamp(snapNearest(minVal, this.step), 0, this.rangeMax);
      maxVal = clamp(snapNearest(maxVal, this.step), 0, this.rangeMax);

      if (minVal > maxVal) maxVal = minVal;

      this.minRange.value = String(minVal);
      this.maxRange.value = String(maxVal);

      var isFullRange = minVal <= 0 && maxVal >= this.rangeMax;

      this.minInput.value = !isFullRange && minVal > 0 ? String(minVal) : '';
      this.maxInput.value = !isFullRange && maxVal < this.rangeMax ? String(maxVal) : '';

      this.setInputConstraints(minVal, maxVal);
      this.updateVisuals(minVal, maxVal);
      this.reconcilePresets(minVal, maxVal);

      if (dispatchChange) {
        var sourceInput = changeSource === 'max' ? this.maxInput : this.minInput;
        sourceInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    reconcilePresets(minVal, maxVal) {
      if (!this.presetButtons || !this.presetButtons.length) return;
      var rangeMax = this.rangeMax;
      this.presetButtons.forEach(function (button) {
        var minAttr = button.getAttribute('data-preset-min');
        var maxAttr = button.getAttribute('data-preset-max');
        var pMin = minAttr === '' || minAttr == null ? 0 : parseAmount(minAttr) || 0;
        var pMax = maxAttr === '' || maxAttr == null ? rangeMax : parseAmount(maxAttr) || rangeMax;
        var on = minVal === pMin && maxVal === pMax;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    setInputConstraints(minVal, maxVal) {
      this.minInput.setAttribute('data-max', String(maxVal));
      this.maxInput.setAttribute('data-min', String(minVal));
    }

    updateVisuals(minVal, maxVal) {
      if (this.minDisplay) this.minDisplay.textContent = formatMoney(minVal, this.currencySymbol);
      if (this.maxDisplay) this.maxDisplay.textContent = formatMoney(maxVal, this.currencySymbol);

      if (!this.trackFill || !this.rangeMax) return;

      var minPercent = (minVal / this.rangeMax) * 100;
      var maxPercent = (maxVal / this.rangeMax) * 100;

      this.trackFill.style.left = minPercent + '%';
      this.trackFill.style.width = Math.max(maxPercent - minPercent, 0) + '%';
    }

    syncFromInputs(options) {
      var dispatchChange = options && options.dispatch;
      var minVal = parseAmount(this.minInput?.value);
      var maxVal = parseAmount(this.maxInput?.value);

      if (minVal == null) minVal = 0;
      else minVal = snapNearest(minVal, this.step);

      if (maxVal == null) maxVal = this.rangeMax;
      else maxVal = snapNearest(maxVal, this.step);

      this.applyValues(minVal, maxVal, Boolean(dispatchChange));
    }
  }

  if (!customElements.get('plp-price-range')) {
    customElements.define('plp-price-range', PlpPriceRange);
  }

  document.addEventListener('plp-facets:updated', function () {
    document.querySelectorAll('plp-price-range').forEach(function (element) {
      if (typeof element.syncFromInputs === 'function') {
        element.syncFromInputs({ dispatch: false });
      }
    });
  });
})();
